import Highscore from './Highscore';

export default Highscore;